import { objectOf /*, maybe */ } from "@altostra/type-validations";

export const isCanvasStepResult = objectOf({});
